// @flow
import { connect } from 'react-redux';

import NextGameSwiper from 'components/billboard/NextGamesSwiper';
import { fetchRencontresArticle } from 'actions/rencontreActions';
import type { DispatchProps, StateProps } from 'components/billboard/NextGamesSwiper';
import type { DispatchType, StateType } from 'types/Actions';

const mapStateToProps = (state: StateType): StateProps => ({
  rencontresLive: state.rencontreLiveState.rencontres,
  rencontresArticle: state.rencontreState.rencontresArticle
});

const dispatchStateToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchRencontresArticle: (ids: string[]) => dispatch(fetchRencontresArticle(ids))
});

export default connect(mapStateToProps, dispatchStateToProps)(NextGameSwiper);
